import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MailIcon, MessageCircleIcon, PhoneIcon, Rotate3dIcon, SendIcon, BoxIcon } from "lucide-react";
import { contact } from "../../data/contact";
import { useEnquiryModal } from "../../contexts/EnquiryModalContext";
interface DockItem {
  label: string;
  ariaLabel: string;
  icon: BoxIcon;
  href?: string;
  to?: string;
  external?: boolean;
}
const items: DockItem[] = [{
  label: 'WhatsApp',
  ariaLabel: `Message us on WhatsApp at ${contact.whatsappDisplay}`,
  icon: MessageCircleIcon,
  href: contact.whatsappLink,
  external: true
}, {
  label: 'Call',
  ariaLabel: `Call us at ${contact.phoneDisplay}`,
  icon: PhoneIcon,
  href: contact.phoneLink
}, {
  label: 'Email',
  ariaLabel: `Email us at ${contact.email}`,
  icon: MailIcon,
  href: contact.emailLink
}, {
  label: 'Virtual tour',
  ariaLabel: 'Take a virtual tour of our campuses',
  icon: Rotate3dIcon,
  to: contact.virtualTourPath
}];
const itemClass = 'flex w-[60px] flex-col items-center gap-1 rounded-[14px] py-2 type-fine font-bold text-ink transition-colors duration-150 hover:bg-mist focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand sm:w-[74px] md:w-[92px]';

// Floating bottom dock: the enquiry popup plus the quickest ways to reach ES World.
export function FloatingContactDock() {
  const {
    open
  } = useEnquiryModal();
  return <div className="pointer-events-none fixed inset-x-0 bottom-4 z-30 flex justify-center px-4 md:bottom-6" data-id="element-537" data-mp="2c5evpkchm7ti">
      <motion.nav aria-label="Contact ES World" className="pointer-events-auto flex rounded-[20px] border border-line bg-white p-1.5 shadow-lift" initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.28,
      delay: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-538" data-mp="2h25b05ggwzdv">
        <button type="button" onClick={() => open()} aria-haspopup="dialog" className="mr-1 flex flex-col items-center justify-center gap-1 rounded-[14px] bg-brand px-3 py-2 type-fine font-bold text-white transition-colors duration-150 hover:bg-brand-hover active:bg-brand-press focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 md:px-5" data-id="element-539" data-mp="qtdhe1r5v714">
          <SendIcon className="h-5 w-5" aria-hidden="true" data-id="element-540" data-mp="2okwh4i3w9jli" />
          <span className="whitespace-nowrap" data-id="element-541" data-mp="2jmux9uyn9g8z">Enquire now</span>
        </button>
        {items.map(({
        label,
        ariaLabel,
        icon: Icon,
        href,
        to,
        external
      }) => {
        const content = <>
              <Icon className="h-5 w-5 text-brand" aria-hidden="true" data-id="element-542" data-mp="2apknyf5e016p" />
              <span className="whitespace-nowrap" data-id="element-543" data-mp="25on4lz8n513m">{label}</span>
            </>;
        return to ? <Link key={label} to={to} aria-label={ariaLabel} className={itemClass} data-id="element-544" data-mp="20qbvjqq66umg">
              {content}
            </Link> : <a key={label} href={href} aria-label={ariaLabel} className={itemClass} {...external ? {
          target: '_blank',
          rel: 'noreferrer'
        } : {}} data-id="element-545" data-mp="3vz07mk9g7m9">
              {content}
            </a>;
      })}
      </motion.nav>
    </div>;
}